import { BACKDROP_CONSTANTS } from '../backdrop';
import { COMPONENT_NAME_PREFIX } from '../constants';
import { LINEAR_PROGRESS_CONSTANTS } from '../linear-progress';
var elementName = COMPONENT_NAME_PREFIX + "busy-indicator";
var classes = {
    SURFACE_INVISIBLE: 'tyl-busy-indicator__surface--invisible'
};
var selectors = {
    SURFACE: '.tyl-busy-indicator__surface',
    SURFACE_INVISIBLE: "." + classes.SURFACE_INVISIBLE,
    TITLE: '.tyl-busy-indicator__title',
    MESSAGE: '.tyl-busy-indicator__message',
    CANCEL: '.tyl-busy-indicator__cancel-button',
    SPINNER: '.tyl-busy-indicator__spinner',
    PROGRESS_BAR_CONTAINER: '.tyl-busy-indicator__progress-container',
    PROGRESS_BAR: ".tyl-busy-indicator__progress-container " + LINEAR_PROGRESS_CONSTANTS.elementName,
    BACKDROP: BACKDROP_CONSTANTS.elementName
};
var events = {
    CANCEL: elementName + "-cancel"
};
var strings = {
    CANCELLING: 'Cancelling...',
    DEFAULT_MESSAGE_ID: '__DEFAULT_MESSAGE_ID__'
};
var attributes = {
    TITLE_TEXT: 'title-text',
    MESSAGE: 'message',
    CANCEL: 'cancel',
    SPINNER: 'spinner',
    PROGRESS_BAR: 'progress-bar',
    PROGRESS_BAR_DETERMINATE: 'progress-bar-determinate',
    PROGRESS: 'progress',
    BUFFER: 'buffer',
    WIDTH: 'width',
    DIRECTION: 'direction',
    AUTO_ELLIPSIS: 'auto-ellipsis',
    MINIMUM_VISIBLE_LIFETIME: 'minimum-visible-lifetime',
    DELAY: 'delay',
    MANAGE_FOCUS: 'manage-focus',
    PARENT_OPEN: 'tcw-busy-indicator-open'
};
var numbers = {
    DELAY: 500,
    TRANSITION_LENGTH: 120,
    MINIMUM_VISIBLE_LIFETIME: 1000
};
export var BUSY_INDICATOR_CONSTANTS = {
    elementName: elementName,
    selectors: selectors,
    events: events,
    strings: strings,
    attributes: attributes,
    numbers: numbers,
    classes: classes
};
